import {Observable} from "rxjs";

export class MutationObservable extends Observable<MutationRecord[]> {

  constructor(domNode: Node, options: MutationObserverInit) {
    super((subscriber) => {
        const mutationObserver = new MutationObserver(mutations => subscriber.next(mutations));
        mutationObserver.observe(domNode, options);
        return () => mutationObserver.disconnect();
    });
  }
}
